import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFullScreen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFullScreen"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H9V4.5H4.5V9H3V3ZM15 3H21V9H19.5V4.5H15V3ZM4.5 15V19.5H9V21H3V15H4.5ZM21 15V21H15V19.5H19.5V15H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFullScreen;
